<template>

      <div id="editor" class="editor_wrap"  >
        <div class="header_" >
          <div style="width:15%;cursor:pointer; ">
            <img   :src="require('@/assets/images/newlogo.png')"   width="134px" height="50px"  @click="BackToHome" >
             <!-- src="@/assets/images/newlogo.png"  -->
          </div>
           
          <div style="width:35%;font-size:28px;color:#dedede; ">  </div> 
          
          <div class="head_operation"  >
            <!-- <i v-if="mode=='drafts' || mode=='mine' " class="el-icon-edit"  @click="ModifyMyArticle" title="编辑"></i>
            <i v-if=" mode=='mine' "  class="el-icon-share" title="分享"></i>
            <i v-if="mode=='drafts' || mode=='mine' " class="el-icon-delete" @click="ConfirmDelete"   title="删除"></i>
 
            
            <el-button v-if="mode=='drafts' && article.isIssued!='yes'" type="primary" @click="IssueMyArticle"  style="width:100px;margin-left:50px">发布</el-button> -->

                      
          </div>
          
          <div v-if="!isMini" class="loginAvatar">
     
            <el-avatar v-if="!islogin" title="登录" :src="require('@/assets/images/touxiang.png')" style="margin-right:20px;cursor:pointer; " @error="errorHandler" @click.native="SignIn"  >
                  
            </el-avatar>

            <el-dropdown v-else >
        
              <el-avatar  :src="userInfo.avatarUrl" style="margin-right:20px;cursor:pointer" @error="errorHandler" >
                  <img :src="userInfo.avatarUrl"/>
              </el-avatar>
              <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="SignOut">退出登录</el-dropdown-item>

                  <el-dropdown-item  command="deposit"  @click.native="Turn2Charge" >
                  
                    <span class="iconfont"    >&#xe71b;</span>
                      充值({{$store.state.accountInfo.coins}})
                  </el-dropdown-item> 
                
              </el-dropdown-menu> 



            </el-dropdown>

          </div>

        
        </div>

        <div class="middle" :style="isphone? 'min-height:'+screenHeight*0.88+'px;width:'+screenWidth*0.98+'px;padding:5px;' :'min-height:'+screenHeight*0.88+'px' ">
          <div class="left"  v-if="!isphone"></div>
          <!-- :style=" isphone? 'width:94%;margin-left:auto;margin-right:auto;':'' " -->
          <div class="mid_"  :style="isphone?'width:100%':''">
            <h1 class="contract_title" style="text-align:left" >{{article.title || '未知标题'  }} </h1> 

            <!-- <div class="starBar">  
         
              <div class="op"  v-if="isstared=='yes'"  >
  
                <el-button-group style="display:flex;flex-direction:row;height:70%; ">

                  <el-button @click="UnstarHandle" :disabled="article.userid==userInfo.userId ||''? true:false" type="info" plain icon="el-icon-star-off" style="height:100%;padding:0 10px 0 10px">UnStar</el-button>
                  <el-button  type="info" plain  style="height:100%;min-width:10px;border-left: 1px solid #dedede;padding:7px">{{article.likes}}</el-button>
             
                </el-button-group>



              </div>
 
            </div> -->


            <div class="author" @click="Turn2Profile">
                <el-avatar  :src="article.avatarUrl"  @error="errorHandler"   >
                </el-avatar>
                <span style="margin-left:20px;font-weight:bold">{{article.authorName}}</span>
            </div>

            <div class="affix" > 
              
 
              <div class="affix item"  v-for="(item,index ) of  article.files"  v-bind:key="item.fileName"  :data-itemId="'file_'+index"  name="fileItem"    data-id="item.id"  :id="'file_'+index"       style=" border-bottom: 1px solid #dedede;border-top:none;"    >
                
                <span    class="affix item icon"   > 
                  <img v-if='item.fileName.indexOf(".pdf")!=-1' src="@/assets/images/PDF.png" alt=""> 
                  <img v-else-if='item.fileName.indexOf(".doc")!=-1' src="@/assets/images/word.png" alt=""> 
                  <img v-else-if='item.fileName.indexOf(".xlsx")!=-1 || item.fileName.indexOf(".csv")!=-1' src="@/assets/images/excel.png" alt=""> 
                  <img v-else-if='item.fileName.indexOf(".ppt")!=-1 || item.fileName.indexOf(".pptx")!=-1' src="@/assets/images/ppt.png" alt=""> 
                  <img v-else-if='item.fileName.indexOf(".rar")!=-1 ||item.fileName. indexOf(".zip")!=-1' src="@/assets/images/yasuowenjian.png" alt=""> 
                  <img v-else-if='item.fileName.search(/.bmp|.jpg|.jpeg|.png|.tif|.gif|.pcx|.tga|.exif|.fpx|.svg|.webp|.WMF/i)!=-1 ' src="@/assets/images/tupian_wenjian.png" alt=""> 
                  <img v-else-if='item.fileName.search(/.wav|.flac|.ape|.alac|.mp3|.aac|.Opus/i)!=-1  ' src="@/assets/images/yinpin.png" alt=""> 
                  <img v-else-if='item.fileName.search(/.rm|.rmvb|.mpeg|.mov|.mtv|.dat|.wmv|.avi|.3gp|.flv|.mp4/i)!=-1  ' src="@/assets/images/yinpin.png" alt=""> 

                  <img v-else   src="@/assets/images/unknowfile.png" alt=""> 
                  
                </span>
 
                <span class="affix item left" style="padding-left:10px"   :title="item.fileName">   
                  <el-tag type="warning" effect="dark" v-if="item.price &&item.price>0" style="margin:auto 10px auto 0;font-size:14px;height:70%;line-height:28px"> <i class="el-icon-coin"></i> {{item.price}} </el-tag>  
                  {{item.fileName}} 
                </span>
                <span class="affix item mid" >{{item.dec}}</span>
               
                <div class="affix item right" >
                  <!-- <span class="fileUpdateTime">{{ item.time}}</span> -->
                 
                  <el-button type="info" plain icon="el-icon-download" style="height:70%;padding:0 10px 0 10px" @click="DownLoadFile(item)">下载 </el-button>
                 
        
                  
                </div>


                  <div class="affix item right" >
        
                    <el-button type="info" plain icon="el-icon-download" style="height:70%;padding:0 10px 0 10px" @click="DownLoadFile_byJs(item)">网页格式下载 </el-button>
                    
                  </div>

                 
              </div>


              <div class="affix item"  v-if="article.files && article.files.length==0">
                <span    class="affix item icon"   > 
                    <img   src="/static/img/word.png" alt=""> 
                </span>

                <span class="affix item left" style="padding-left:10px;width:65%"     v-cloak>   
               
                    {{article.title}}  
                </span>
                <!-- <span class="affix item mid"  v-cloak> 本文档免费且不计下载次数 </span> -->
                 
                <div class="affix item right"  style=" width:35%">
    
                
                    <!-- <el-button type="info" plain icon="el-icon-download" style="height:70%;padding:0 10px 0 10px;"  @click="save2docx">下载</el-button> -->
                    <el-button type="info" plain icon="el-icon-download" style="height:70%;padding:0 10px 0 10px;"  @click="DownLoadFile({},'from_web')">下载</el-button>
            
                 
                </div>

                 
            
            
            </div>



              
              
            </div>

            <!-- <div class="affix" style="margin-top:10px"> 
              
              <div class="affix firstline" style="border: 1px solid #c8e1ff;">
                <div class="affix firstline left">
                  <span style="margin-left:10px"></span>
                   
                
                </div>
                <div class="affix firstline right"> 最后更新于 2019-10-01 </div>
              </div>
              
              <div class="affix item" style=" border: 1px solid #dedede;border-top:none">
                <span class="affix item icon"> <img src="@/assets/images/PDF.png" alt=""> </span>

                <span class="affix item left" style="padding-left:10px" >律师装逼指引文件.pdf</span>
                <span class="affix item mid" >555</span>
                <span class="affix item right" >2 months ago</span>

                 
              </div>
              
              
            </div> -->

            <!-- <el-divider></el-divider> -->

            <!-- <el-divider><i class="el-icon-paperclip"></i></el-divider> -->
             <!-- style="height:1168px;  " -->
            <div    >
              <img src="@/assets/images/white_pic.png" alt="" id="hideimg" class="hideimg" > 
              <div v-html="doc"  id='content_'   >
  
              </div>

            </div>
          

    <!-- <div class="page"  id='content_' v-html="doc" contenteditable="true" >   

    </div> -->


            <!-- <div class="html_content"  v-resize="DomResize"  id='content_' v-html="doc"  :style="isphone? 'width:'+screenWidth*0.98+'px':''  "></div> -->

            <div  style="margin-top:30px; color:#909090;font-size:16px">编辑于 {{timestampToTime(article.updateTime)||'' }}</div>

            <div class="tagsBar">
              <span v-if="article.tags&&article.tags[0]  "><el-tag>{{article.tags[0]}}</el-tag></span> 
              <span v-if="article.tags&&article.tags[1]  "><el-tag type="success">{{article.tags[1]}}</el-tag></span> 
              <span v-if="article.tags&&article.tags[2]  "><el-tag type="warning">{{article.tags[2]}}</el-tag></span> 
            </div>            
            <div style="height:200px;"></div>
   
          </div>
          <div class="right" v-if="!isphone"></div>
























        </div>
       
 

        <el-dialog
          width="200px"
          title="微信扫一扫"
          @close="closeCode"
          :visible.sync="shareVisible"
          append-to-body>
          <div class="sharecode">
            <div id="qrcode" ref="qrcode"></div>
          </div>
        </el-dialog>

 
        
     
       
      </div>
  
     
</template>

<script>

var    quill_css=   `
    <style>

  
 
.template-content td{border:1px solid #535c6b}
.template-content a[name]{display:block;height:0;overflow:hidden;position:relative;top:-100px}
.template-content ol{margin:0;padding:0}.template-multiple-title{position:relative}
.template-multiple-title:before{background:#00bdaa;content:"";display:block;height:16px;left:-8px;position:absolute;top:3px;width:4px}
.template-multiple-list{line-height:28px}.template-multiple-list a:not(.font-bold):hover{color:#00a393}
.template-preview-showmore{background:#fafbfc;border-radius:0 0 4px 4px;bottom:-1px;color:#00a393;display:block;left:-1px;line-height:52px;opacity:.9;position:absolute;text-align:center;width:calc(100% + 2px)}.template-relate-content{background:#fafbfc;border-radius:4px;padding:20px}.template-relate-content .templates-item-info{cursor:pointer}.template-relate-content .templates-item-info:hover{color:#00a393}
.template-aside{padding:40px}
</style>
  `


 
import QRCode  from "qrcodejs2"
// import VueQArt from 'vue-qart'

// var wx = require('weixin-js-sdk');
import wx from 'weixin-js-sdk'
import axios from 'axios'
import saveAs from '@/assets/js/html2word/FileSaver.js'
import htmlDocx from '@/assets/js/html2word/html-docx.js'
var weixinJDK={}
weixinJDK.timestamp=Date.parse(new Date())/1000
weixinJDK.appId= 'wx5b2080a9450184a9'
weixinJDK.nonceStr=random_str(16)
// weixinJDK.jsApiList=['updateAppMessageShareData','updateTimelineShareData']


let datas_1= { 
  weixinJDK: weixinJDK,
  url:window.location.href
}

  // this.axios.withCredentials=false
axios.post('https://www.lawtip.cn/PHPserver/weixin/get_wxjdk.php', {
params: datas_1 },{withCredentials:false}
  ).then( (res)=> {
    // window.console.log(res)
    if(res.status==200){
      var result=res.data
      window.console.log(result)
      weixinJDK.signature=result
      // window.console.log('weixinJDK:',weixinJDK)
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: 'wx5b2080a9450184a9', // 必填，公众号的唯一标识
        timestamp:  weixinJDK.timestamp, // 必填，生成签名的时间戳
        nonceStr:weixinJDK.nonceStr, // 必填，生成签名的随机串
        signature: weixinJDK.signature,// 必填，签名
        jsApiList: ['updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline','showMenuItems','hideMenuItems','miniProgram.navigateTo','miniProgram.navigateBack','wx.miniProgram.postMessage','wx.miniProgram.getEnv'] // 必填，需要使用的JS接口列表  
        //“分享给朋友”及“分享到QQ” ,“分享到朋友圈”及“分享到QQ空间”
      });

      // if(result.status=='ok'){
      //   weixinJDK.signature=result.data
      // }


    }
    
}).catch(function (error) {
  window.console.log(error);
});


wx.ready(function(res){
  window.console.log(res);
  // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

});

wx.error(function(res){
  window.console.log(res);
  // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
});


wx.ready(function (res) {    
  window.console.log(res);
  wx.updateAppMessageShareData({ 
    title: document.title, // 分享标题
    desc: document.title, // 分享描述
    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'https://www.lawtip.cn/images/logo.png', // 分享图标
    success: function () {
      // 设置成功
      window.console.log('success');
    },
    fail(res){
      window.console.log('fail res:',res);
    }
  })
});

wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
  wx.updateTimelineShareData({ 
    title: document.title, // 分享标题
    link: window.location.href,  // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'https://www.lawtip.cn/images/logo.png', // 分享图标
    success: function () {
      // 设置成功
      window.console.log('success');
    },
    fail(res){
      window.console.log('fail res:',res);
    }
  })
});


// wx.ready(function () {   
//   window.console.log('wx.showMenuItems():',wx.showMenuItems())

// });


function random_str(number){
  return Math.random().toString(36).substr(2).slice(1,number+1)
}

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

function getNum() {
  var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
      'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
      'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
      'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
      'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
      'x', 'y', 'z'];
  var nums = "";
  for (var i = 0; i < 8; i++) {
    var id = parseInt(Math.random() * 61);
    nums += chars[id];
  }
  return nums;

}

function delCookie () {  //清空所有cookie
    var keys = document.cookie.match(/[^ =;]+(?==)/g)
    if (keys) {
        for (var i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
        document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
        document.cookie = keys[i] + '=0;path=/;domain=ratingdog.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
        }
    }
}






      













export default {
        name: 'article',
        // inject:['reload'],
        components: {
        //  QRCode,
 
        },
		// props: {
		// 	pageId: String
        // },
        data() {
			return { 
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                isphone:false,
                pages:1,
                doc:'',
                islogin:false,
                userInfo:{},
                accountInfo:{},
                // link:'https://baidu.com',
                shareVisible:false,
                commentsWindow:false,
                myComment:'',
                commentList:[],
                comment_number:0,
                comment_page:1,
                comment_sort:'like',
                // comment_scrollHeight:0,
                // comment_clientHeight:0,
                // comment_scrollTop:0,
                comments_sig:true,
                weixinJDK:'',
                // downloadButton:false,
                // config: {
                //   value: 'https://baidu.com',
                //   imagePath: '/static/logo/logo.png',
                //   filter: 'color'
                // },

                mode:'',
                article_mode:0,
                ua:'',
                isMini:false,
                token:'',
                // sortItem:'最近更新',

                // squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",

                // ratecolors: ['#99A9BF', '#F7BA2A', '#FF9900'] , // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
                // value2:3,
                // search_input:'',

                 
                // articleTitle:'',
                article:{
                  title:'',
                  article_type:'请选择文章类型',
                  content:'',
                  imgs:[],
                  delete_imgs:[],
                    
                },
                // draft_status:'草稿',
                // lastsave:{time:new Date().getTime(),content:'' }
                // author:{},
                 
             
                i:0,  //滚轮上下监听元素
                bottom_op_onshow:false,
                bottom_op_onshow_sig:0,
                isstared:'no',
                docid:'',

                mylikes:{},
                mydislikes:{},

                scroll_timeout:'',
            }
        },
        created(){
          wx.miniProgram.getEnv(function(res) {
            window.console.log(res.miniprogram) // true
          })

          // window.console.log(navigator.userAgent)
        
          


          this.islogin=sessionStorage.getItem('isLogin') || false;
          if(this.islogin=='false'){
            this.islogin=false
          }

    
          // console.log(' this.islogin:', this.islogin)
          // console.log(typeof(this.islogin))
         
          if(this.islogin ){
            // console.log(' this.islogin2:', this.islogin)

            let userInfo=sessionStorage.getItem('userInfo') || ''
            let accountInfo=sessionStorage.getItem('accountInfo') || ''

            window.console.log('userInfo:',userInfo)
            if (userInfo){
              this.userInfo= JSON.parse(userInfo)
            }
            if (accountInfo){
              this.accountInfo= JSON.parse(accountInfo)
            }

          //  window.console.log('this.userInfo:',this.userInfo)  

          }else{
            // console.log(' this.islogin3:', this.islogin)

          }


           var that=this
            // console.log("+++++++++++++:", this.$route)
            this.mode = this.$route.params.mode;   //article,drafts,mine
            // this.mode = this.$route.query.mode; 
            window.console.log('this.mode:',this.mode)

            this.article_mode=this.mode

            this.docid=this.$route.params.id; 
             
            window.console.log('docid:',this.docid)

            // this.link= window.location.href
            // window.console.log('window.location.hre::',window.location.href)

            if(this.isMini){
              this.isstared=this.$route.query.isstared
              this.token=this.$route.query.token
            }else{
              this.isstared=sessionStorage[this.docid]
            }

            window.console.log('this.isstared:',this.isstared)


            
            // window.console.log(this.isstared)
            var datas= { 
                docid:this.docid,
                whattodo: "get_article2"
            }
            this.axios.post(this.$root.rootUrl +'article_getdoc',datas
            ).then(function (res) {
                // window.console.log('article 1111111111111 res:',res)
                // that.saving_sig=0
                if(res.status==200){
                  let result=res.data
                  if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                  }else if (result.status=='ok'){
                      // that.article=result.data._source
                      var article=result.data //._source
                      document.title = result.data.title

                      let files=result.data.files || []
        

                      that.article=article
                      // window.console.log('that.article:',that.article)
                      that.doc=   '<article class="page" >' +  article.content +'</article>'  //contenteditable="true"
                      // console.log('----------initial  that.doc:',that.doc)


                      // that.doc=     article.content  

                      setTimeout( () =>{
                        var obj = document.getElementById("content_");
                        let w = obj.offsetWidth;    // 返回元素的总宽度
                        let h = obj.offsetHeight;    // 返回元素的总高度
                        let t=obj.offsetTop

                        // console.log("$('content_').outerHeight(true):",$(obj).outerHeight(true))

                        let hidImg=document.getElementById("hideimg")
                        hidImg.style.height=$(obj).outerHeight(true)+'px'
                        hidImg.style.width=$(obj).outerWidth(true)+'px'

                        // console.log(w)
                        console.log(h)
                        // console.log(t)

                        let pages= Math.ceil(h/1168)

                        var parr=obj.getElementsByTagName("*")
                       
                        // var parr=obj.children
                        // console.log('parr:',parr)
                        var len=parr.length
                        let i=1
                        let totalH=0
                        let clientH 
                        let currentH=0
                        let last_top=t
                        // baseH=h
                        // for(i;i<len;i++){
                        //   totalH=parr[i].clientHeight+totalH
                        //   if(totalH>1168 && i>0){
                        //     parr[i].innerHTML='</div><div class="page" contenteditable="true">'+parr[i].innerHTML
                        //     totalH=0
                        //   }
                        // }

                        // debugger
                        // return
  
                        for(i;i<len-1;i++){   //let target of parr
                    
                          // console.log('clientHeight before:',p.clientHeight)
                          
                          // if(i==0){
                          //   clientH=p.offsetTop-t

                          // }else{
                          //   clientH=p.clientHeight

                          // }
                          // clientH=parr[i].outerHeight(true)
                          clientH=$(parr[i]).outerHeight(true)
                          // if(parr[i].offsetTop==0){
                          //   continue
                          // }

                           
                          if(parr[i].offsetTop>0 && parr[i].offsetTop>parr[i-1].offsetTop && clientH<1168){
                            currentH=parr[i].offsetTop-last_top+clientH
                          } 
                       
                          // if(i==0 || clientH>1168 || parr[i].firstElementChild){
                         
                          //   continue
                          // }
                          if(clientH==0 && parr[i].tagName=='BR'){
                            currentH=44+currentH
                          }

                          // totalH=clientH+totalH

                          // console.log('current target :',parr[i])
                          // console.log('current offsetTop :',parr[i].offsetTop)
                  
                          // console.log('currentH:',currentH)

                          // console.log('totalH:',totalH)
                          if(currentH>1168 ){
                            // let o='</div><div class="page" contenteditable="true">'+p.outerHTML
                            // let o='<div class="mark">mark</div>'+p.outerHTML

                            // console.log('o:',o)
                            // parr[i].outerHTML=o
                            // p.outerHTML=o
                            // p.outerHTML='</div><div class="page" contenteditable="true">'+p.outerHTML
                            parr[i].outerHTML='<span>mark</span>'+parr[i].outerHTML  //死循环
                            i++
                            last_top=parr[i].offsetTop+clientH
                            // console.log('p.outerHTML:',parr[i].outerHTML)
                            currentH=0
                            // totalH=0
                          }

                          // if(i==0){
                          //   p.innerHTML='<div class="page" contenteditable="true">'+p.innerHTML
                          // }else if(i==len-1){
                          //   p.innerHTML=p.innerHTML+'</div>'
                          // }

                          // i++
                        }

                        // console.log('obj:',obj)
                        let newobj=obj.outerHTML
                      
                        newobj=newobj.replace(/<span>mark<\/span>/g,'</article><article class="page" >')      // contenteditable="true"
                        that.doc=newobj

                        // console.log('that.doc:',that.doc)

                      },100)

                
                      // that.getCommentt_num(that.docid)
                  } else if (result.status=='fail'){
                      that.$message(result.failMsg?result.failMsg:'获取失败，请稍后再试');
                      
                  }

                }

                
            }).catch(function (error) {
                window.console.log(error);
                // that.saving_sig=0
            });

            var mylikes=localStorage.getItem("mylikes") || '';
            if (mylikes){
              this.mylikes=JSON.parse(mylikes);
            }
            var mydislikes=localStorage.getItem("mydislikes") || '';
            if (mydislikes){
              this.mydislikes=JSON.parse(mydislikes);
            }

        },
        // watch : {
        //   doc:function(){
        //     console.log('==============')
 

 

        //   }
        // },
        mounted() {
            
            var x=document.getElementById("head_tip")
            if(x){
              x.remove(0)
            }
            // x=document.getElementById("Header")
            // if(x){
            //   x.remove(0)
            // }
            this.$emit('ChangeFunctionBox','header_onshow_off'); 

            let ua=navigator.userAgent
            let isMini=ua.indexOf("miniProgram") 
            this.us=ua
            if(isMini!=-1){
              this.isMini=true
               
            } 
            window.console.log('this.isMini:',this.isMini)

           
            this.isphone=isphone()
             


          
            window.scrollTo(0,0);
            window.addEventListener('scroll', this.handleScroll, true); 
  
            window.console.log('mounted,this.$route.params:',this.$route.params)
            






 
        },
        methods:{
          //  beforeRouteLeave(to, from, next) {
          //       // 设置下一个路由的 meta
          //       to.meta.keepAlive = true;  // B 跳转到 A 时，让 A 缓存，即不刷新
          //       next();
          //   },
          // reload () {
          //     this.isRouterAlive = false;            //先关闭，
          //     this.$nextTick(function () {
          //         this.isRouterAlive = true;         //再打开
          //     }) 
          // },
 

          BackToHome(){ 
            this.$router.push({name:'community'})
            this.$emit('ChangeFunctionBox','header_onshow_on'); 
          },
          LikeHandle(comment_id,index){
            if(!this.islogin){
                this.$message({
                    message: '请先登录哦',
                    type: 'warning'
                });
                return
              }
  
              var that=this
              var datas= { 
                comment_id: comment_id,
                whattodo: "like_this_comment",
                // docid:this.docid
              }

              this.axios.post('https://api.lawtip.cn/article',datas
              ).then(function (res) {
                  window.console.log(res)
                  if(res.status==200){
                      let result=res.data
                      if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });
                      }else if (result.status=='ok'){
                        window.console.log(result)
                        let mylikes=localStorage.getItem("mylikes") || {};
                        if (mylikes.length>0){
                          mylikes=JSON.parse(mylikes);
                          mylikes[comment_id]='1'
                        }else{
                          mylikes[comment_id]='1'
                        }
                        that.mylikes=mylikes
                        window.console.log('mylikes:',mylikes)
                        localStorage.setItem("mylikes",JSON.stringify(mylikes));
                        that.commentList[index]._source.like++
                      } else if (result.status=='fail'){
                        that.$message('点赞失败');
                          
                      }


                      
                  }

                  
              }).catch(function (error) {
                  window.console.log(error);
                  // that.saving_sig=0
              });

          },
          Cancle_LikeHandle(comment_id,index){
              if(!this.islogin){
                    this.$message({
                        message: '请先登录哦',
                        type: 'warning'
                    });
                    return
                }
  
              var that=this
              var datas= { 
                comment_id: comment_id,
                whattodo: "cancle_like_this_comment",
                // docid:this.docid
              }

              this.axios.post('https://api.lawtip.cn/article',datas
              ).then(function (res) {
                  window.console.log(res)
                  if(res.status==200){
                      let result=res.data
                      if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });
                      }else if (result.status=='ok'){
                        window.console.log(result)
                        let mylikes=localStorage.getItem("mylikes") || {};
                        if (mylikes.length>0){
                          mylikes=JSON.parse(mylikes);
                          if (mylikes[comment_id]){
                            delete mylikes[comment_id];
                            that.mylikes=mylikes
                          }
                        }
                        that.mylikes=mylikes
                        // var d=JSON.stringify(data);
                        localStorage.setItem("mylikes",JSON.stringify(mylikes));
                        if(that.commentList[index]._source.like>0){
                          that.commentList[index]._source.like--
                        }
                       

                      } else if (result.status=='fail'){
                        that.$message('取消点赞失败');
                          
                      }


                      
                  }

                  
              }).catch(function (error) {
                  window.console.log(error);
                  // that.saving_sig=0
              });

          },
          DislikeHandle(comment_id,index){
              if(!this.islogin){
                    this.$message({
                        message: '请先登录哦',
                        type: 'warning'
                    });
                    return
                }
  
              var that=this
              var datas= { 
                comment_id: comment_id,
                whattodo: "dislike_this_comment",
                // docid:this.docid
              }

              this.axios.post('https://api.lawtip.cn/article',datas
              ).then(function (res) {
                  window.console.log(res)
                  if(res.status==200){
                      let result=res.data
                      if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });
                      }else if (result.status=='ok'){
                        window.console.log(result)
                        let mydislikes=localStorage.getItem("mydislikes") || {};
                        if (mydislikes.length>0){
                          mydislikes=JSON.parse(mydislikes);
                          mydislikes[comment_id]='1'
                        }else{
                          mydislikes[comment_id]='1'
                        }
                        that.mydislikes=mydislikes
                        // var d=JSON.stringify(data);
                        localStorage.setItem("mydislikes",JSON.stringify(mydislikes));
                        that.commentList[index]._source.dislike++


                      } else if (result.status=='fail'){
                        that.$message('踩失败');
                          
                      }


                      
                  }

                  
              }).catch(function (error) {
                  window.console.log(error);
                  // that.saving_sig=0
              });

          },
          Cancle_DislikeHandle(comment_id,index){
              if(!this.islogin){
                    this.$message({
                        message: '请先登录哦',
                        type: 'warning'
                    });
                    return
                }
  
              var that=this
              var datas= { 
                comment_id: comment_id,
                whattodo: "cancle_dislike_this_comment",
                // docid:this.docid
              }

              this.axios.post('https://api.lawtip.cn/article',datas
              ).then(function (res) {
                  window.console.log(res)
                  if(res.status==200){
                      let result=res.data
                      if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });
                      }else if (result.status=='ok'){
                        window.console.log(result)
                        let mydislikes=localStorage.getItem("mylimydislikeskes") || {};
                        if (mydislikes.length>0){
                          mydislikes=JSON.parse(mydislikes);
                          if (mydislikes[comment_id]){
                            delete mydislikes[comment_id];
                            that.mydislikes=mydislikes
                          }
                        }
                        that.mydislikes=mydislikes
                        // var d=JSON.stringify(data);
                        localStorage.setItem("mydislikes",JSON.stringify(mydislikes));
                        if(that.commentList[index]._source.dislike>0){
                          that.commentList[index]._source.dislike--
                        }
                        


                      } else if (result.status=='fail'){
                        that.$message('取消踩失败');
                          
                      }


                      
                  }

                  
              }).catch(function (error) {
                  window.console.log(error);
                  // that.saving_sig=0
              });

          },
          issueMyComment(){
              if(!this.islogin){
                    this.$message({
                        message: '请先登录哦',
                        type: 'warning'
                    });
                    return
                }
              if(this.myComment.length<2){
                if(!this.islogin){
                  this.$message({
                    message: '评论不得少于两个字哦',
                    type: 'warning'
                  });
                  return
                }
              }
              var that=this
              var comment_id=random_str(4)+  (new Date().getTime()+'').slice(3,13)
              var datas= { 
                // article:this.article,
                comment_id: comment_id,
                docid:this.docid,
                whattodo: "makeComment",
                // userInfo:this.userInfo,
                reply_id:'',
                myComment:this.myComment
              }

              this.axios.post('https://api.lawtip.cn/article',datas
              ).then(function (res) {
                  window.console.log(res)
                  // that.saving_sig=0
                  if(res.status==200){
                      let result=res.data
                      if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });
                      }else if (result.status=='ok'){
                        window.console.log(result)
                        window.console.log('that.userInfo.nicName:',that.userInfo.nicName)
                         
                        let obj={_id:comment_id , _source:{ comment:that.myComment,docid:that.docid,like:0,dislike:0,nickName:that.userInfo.nickName,userId:that.userId,time:'刚才',avatarUrl:that.userInfo.avatarUrl} } 
                        that.commentList.unshift(obj)
                        that.myComment=''
                        that.comment_number++
                        that.$message({
                          message: '评论成功',
                          type: 'success'
                        });


                      } else if (result.status=='fail'){
                        that.$message('评论失败');
                          
                      }


                      
                  }

                  
              }).catch(function (error) {
                  window.console.log(error);
                  // that.saving_sig=0
              });





          },
          Turn2Profile(){
            wx.miniProgram.navigateTo({url: '/pages/tools/intro/intro_detail?id='+this.article.userid})
          },
          CommentHandle(sort,page){
            // window.console.log('__________page:',page);
            var that=this

            if(this.isMini){
              window.console.log('that.docid:',that.docid)
              wx.miniProgram.navigateTo({url: '/pages/news/comments?docid='+that.docid})
              return
            }


            if(page==0){
              this.comments_sig=true
              this.comment_page=1
              this.comment_sort=sort
              page++
              that.commentList=[]
            }

            // if(that.comments_sig==false){
            //   return
            // }
            that.comments_sig==false
            
            var datas= { 
              whattodo: "getComments",
              docid:that.docid,
              comment_page:page,
              comment_sort:this.comment_sort
            }
            this.axios.post('https://api.lawtip.cn/article_getdoc',datas
            ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                        message: '请先登录哦',
                        type: 'warning'
                      });
                    }else if (result.status=='ok'){
                      window.console.log('get comments success')
                      let arr=result.data
                      let len=arr.length
                      window.console.log('706  len:',len)
                      if(len==0 ){
                        that.comments_sig=false
                        return
                      }
                      
                      let t=Date.parse(new Date())/1000
                      for(let i=0;i<len;i++){
                        let  u=arr[i]._source.updateTime
                        if (t-u<=900){
                          arr[i]._source.time='刚刚'
                        }else if(t-u>900 && t-u<1800){
                          arr[i]._source.time='十五分钟前'
                        }else if(t-u>1800 && t-u<3600){
                          arr[i]._source.time='半小时前'
                        }else if(t-u>3600 && t-u<7200){
                          arr[i]._source.time='一小时前'
                        }else if(t-u>7200 && t-u<43200){
                          arr[i]._source.time='两小时以前'
                        }else if(t-u>43200 && t-u<86400){
                          arr[i]._source.time='半天前'
                        }else if(t-u>86400 && t-u<17280){
                          arr[i]._source.time='一天前'
                        }else if(t-u>17280 && t-u<604800){
                          arr[i]._source.time='两天前'
                        }else if(t-u>604800 && t-u<2592000){
                          arr[i]._source.time='一周前'
                        }else if(t-u>2592000 && t-u<7776000){
                          arr[i]._source.time='一个月前'
                        }else if(t-u>7776000 && t-u<15552000){
                          arr[i]._source.time='三个月前'
                        }else if(t-u>15552000 && t-u<31104000){
                          arr[i]._source.time='半年前'
                        }else if(t-u>31104000){
                          arr[i]._source.time='一年前'
                        }
                      }
                      let c = (that.commentList).concat(arr);
                      that.commentList=c
                      // that.commentList= (that.commentList).concat(arr);
                      // (that.commentList).concat(arr);
                      window.console.log('-----------that.commentList:',that.commentList)
                      // that.commentList=arr
                      that.comment_number=result.number
                      if(len<10 ){
                        that.comments_sig=false
                      
                      }else{
                        that.comments_sig==true
                      }


                      
                      // that.commentsWindow=true  

                    } else if (result.status=='fail'){
                      window.console.log('get comments fail')
                      that.$message('获取失败');
                        
                    }else if(result.status=='noresult'){
                      that.comments_sig=false
                    }

                    that.commentsWindow=true  

                }
              
            }).catch(function (error) {
                window.console.log(error);
          
            });




            

          },
            ShareHandle(){
              // var that=this
              window.console.log('click');
              // wx.ready(function(res){
              //   window.console.log(res);
              //   // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
              //   wx.checkJsApi({
              //     jsApiList: ['updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline','showMenuItems','hideMenuItems','miniProgram.navigateTo','miniProgram.navigateBack'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              //     success: function(res) {
              //       window.console.log(res);
              //         // 以键值对的形式返回，可用的api值true，不可用为false
              //         // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              //     }
              //   });
              // });
         

              // wx.updateAppMessageShareData({ 
              //     title: that.article.title, // 分享标题
              //     desc: that.article.title, // 分享描述
              //     link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              //     imgUrl: '', // 分享图标
              //     success: function () {
              //       // 设置成功
              //     }
              //   })
              if(this.isphone){
               window.console.log('share button')
                wx.showMenuItems({
                  menuList:[
                  'menuItem:share:qq',
                  'menuItem:copyUrl',
                  'menuItem:share:appMessage',
                  'menuItem:share:timeline',
                  'menuItem:favorite'
                  ]
                });

              }else{
                  this.shareVisible=true
                  this.$nextTick(() => {
                    this.crateQrcode()
                  })
              }

              // this.shareVisible=true
              // this.$nextTick(() => {
              //   this.crateQrcode()
              // })
           

            },
            crateQrcode () {
              this.qr = new QRCode('qrcode', {
                width: 150,
                height: 150, // 高度
                text: window.location.href // 二维码内容
                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f'
                // foreground: '#ff0'
              })
              // console.log(this.qrcode)
            },
            // 关闭弹框,清除已经生成的二维码
            closeCode () {
              this.$refs.qrcode.innerHTML = ''
            },

            errorHandler() {
                return true
            },
            
            IssueMyArticle(){
                if(this.article.title.length<2){
                  this.$message({
                    message: '标题不得少于2个字符',
                    type: 'warning'
                  });
                  return
                }
                var that=this
                var datas= { 
                  article:this.article,
                  // docid:this.article.docid,
                  whattodo: "preview_issue"
                }

                this.axios.post('https://api.lawtip.cn/article',datas
                ).then(function (res) {
                    window.console.log(res)
                    // that.saving_sig=0
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){
                            // that.$router.push({name:'article_detail',params: {mode:datas.article.docid}})
                            // that.$router.push({name:'article_detail',params: { mode:'article',id:datas.article.docid}})
                            // that.mounted()
                            // that.reload()
                            // that.$router.push({name:'article_detail',params: {mode:'article',id:that.article.docid }})
                            that.mode='article'
                            that.$message({
                              type: 'success',
                              message: '发布成功!'
                            });
                            // if(sig==1){
                           
                            // }else if(sig==0){
                            // setTimeout( ()=>{that.draftstatus='草稿'}  , 3000 )
                            // }

                            // that.article.issueTime=data.issueTime
                            // sessionStorage.setItem('my_article_draft', JSON.stringify(that.article));
                            // that.$message('保存成功');
                        } else if (result.status=='fail'){
                            that.$message('发布失败');
                            
                        }


                        
                    }

                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.saving_sig=0
                });



                


            },

            ModifyMyArticle(){
              window.console.log('this.article.docid:',this.article.docid)
              this.$router.push({name:'my_draft',params: {id:this.article.docid}})

            },

            ConfirmDelete() {
              var that=this
              this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                that.DeleteMyArticle()
                // this.$message({
                //   type: 'success',
                //   message: '删除成功!'
                // });
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });          
              });
            },
            



            DeleteMyArticle(){
                var that=this
                var datas= { 
                  docid:this.article.docid,
                  whattodo: "delete_article"
                }
                this.axios.post('https://api.lawtip.cn/article',datas
                ).then(function (res) {
                    window.console.log(res)
                    // that.saving_sig=0
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){
                           that.$router.push({name:'community'})
                            
                            // if(sig==1){
                           
                            // }else if(sig==0){
                            // setTimeout( ()=>{that.draftstatus='草稿'}  , 3000 )
                            // }

                            // that.article.issueTime=data.issueTime
                            // sessionStorage.setItem('my_article_draft', JSON.stringify(that.article));
                            // that.$message('保存成功');
                            

                        } else if (result.status=='fail'){
                            that.$message('删除失败');
                            
                        }


                        
                    }

                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.saving_sig=0
                });

            },

            BackToLastPage(){
              this.$router.go(-1)
            },



            handleScroll(){
              // 页面滚动距顶部距离
              var that=this
              var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 
                        document.body.scrollTop
              var scroll = scrollTop - this.i;
              this.i = scrollTop;
              // window.console.log('scrollTop:',scrollTop)
              // window.console.log('scroll:',scroll)
              if(scroll<0){
                // window.console.log('up')
              
              }else{
                // window.console.log('down')
                // window.console.log(document.documentElement.clientHeight)
                // window.console.log(window.innerHeight)
              

      

                this.bottom_op_onshow=true  // 评论区 star区是否显示
                clearTimeout(this.scroll_timeout)
                this.scroll_timeout= setTimeout(()=>{this.bottom_op_onshow=false}, 5000 )
              // clearTimeout()
                // window.console.log('that.commentsWindow:',that.commentsWindow)

                if(that.commentsWindow==true){   //评论的dialogue是否显示
                  // window.console.log('+++++that.commentsWindow:',that.commentsWindow)
                  var destination = document.querySelector("#comments");
           

                  //clientHeight+clientHeight>=scrollHeight 的时候滚动条到底部
                  
                  if(that.comments_sig){
                    window.console.log('this.comments_sig:',that.comments_sig)
                    if(destination.scrollTop+destination.clientHeight>=destination.scrollHeight){
                      // let page=that.comment_page+1
                      that.comment_page++
                      that.CommentHandle('',that.comment_page)
                    }
                  }
                  

                }

                // scroll_timeout
                // if (this.bottom_op_onshow)


                // container.scrollTop = container.scrollHeight;

                // var test = window.document.getElementById("comment_el"); 
                // window.console.log('test:',test)
                // var scrollHeight = test.scrollHeight;
                // window.console.log('scrollHeight:',scrollHeight)
                // var innerHeight = test.innerHeight;
                // window.console.log('innerHeight:',innerHeight)
                // var clientHeight = test.clientHeight;
                // window.console.log('clientHeight:',clientHeight)
                // var offsetTop=test.offsetTop
                // window.console.log('offsetTop:',offsetTop)
                // let scrollTop=test.scrollTop
                // window.console.log('_scrollTop:',scrollTop)
          
                // let  scrollTop_ = document.documentElement.scrollTop || document.body.scrollTop;
                // window.console.log('scrollTop_:',scrollTop_)
                // let windowHeight=test.windowHeight
                // window.console.log('windowHeight:',windowHeight)
               

                // if(this.bottom_op_onshow_sig==0){
                //   setTimeout(()=>{this.bottom_op_onshow=false;this.bottom_op_onshow_sig=1;}, 7000 )
                // }
               
               
              }
            },

             timestampToTime(timestamp) {
                if(!timestamp){
                  return ''
                }
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + '';
                // var h = date.getHours() + ':';   //
                // var m = date.getMinutes() + ':';//
                // var s = date.getSeconds();//
                if (M.length==1){
                    M='0' +M
                }
                if (D.length==1){
                    D='0' +D
                }
                return Y + M + D ;  //+ h + m + s
            },

            StarHandle(){
              // if(this.isMini){

              //   return
              // }


                if(!this.islogin  && !this.isMini){
                  this.$message({
                      message: '请先登录哦',
                      type: 'warning'
                  });
                  return
                }

                if(this.article.userid==this.userInfo.userId){
                  this.$message({
                    message: '不可以自己给自己Star哦',
                    type: 'warning'
                  });
                  return
                }

                // window.console.log('docid:',docid)             
                var that=this
                var datas= { 
                  whattodo: "star",
                  docid:that.docid,
                  token:this.token
                }
                // datas['param']=this.param
                this.axios.post('https://api.lawtip.cn/article',datas
                ).then(function (res) {
                  window.console.log(res)
                  if(res.status==200){
                      let result=res.data
                      if(result.status=='badgate'){
                          that.$message({
                              message: '请先登录哦',
                              type: 'warning'
                          });
                      }else if (result.status=='ok'){
                          window.console.log('star success')
                          sessionStorage[that.docid]='yes'
                          that.isstared='yes'
                          that.article.likes++

                          // that.docs.docList[ind]._source.isstared='yes'
                          // that.docs.docList[ind]._source.likes+=1
                          // that.docs.number=result.number
                          // if(that.pagemode=='myarticle'){
                          //     that.myArticle[that.param.page][ind]._source.isstared='yes'
                          // }

                      } else if (result.status=='fail'){
                          window.console.log('star fail')
                          
                      }

                  }
                  
                }).catch(function (error) {
                    window.console.log(error);
             
                });

            },

            UnstarHandle(){
                if(!this.islogin && !this.isMini){
                    this.$message({
                        message: '请先登录哦',
                        type: 'warning'
                    });
                    return
                }
                
                var that=this
                var datas= { 
                    whattodo: "unstar",
                    docid:that.docid,
                    token:this.token
                }
                // datas['param']=this.param
                this.axios.post('https://api.lawtip.cn/article',datas
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){
                            // window.console.log('unstar success')
                            // that.docs.docList[ind]._source.isstared='no'
                            // that.docs.docList[ind]._source.likes-=1
                            // if(that.pagemode=='myarticle'){
                            //     that.myArticle[that.param.page][ind]._source.isstared='no'
                            // }
                            sessionStorage[that.docid]='no'
                            that.isstared='no'
                            that.article.likes--
                        } else if (result.status=='fail'){
                            window.console.log('unstar fail')
                            
                        }

                    }
                  
                }).catch(function (error) {
                    window.console.log(error);
             
                });




            },

            mouseOverItem(index){
              // window.console.log('e:',e);
              // var itemId=e.srcElement.dataset.itemId
              var itemId='file_'+index
              window.console.log('itemId:',itemId);
              // let x=document.getElementById(itemId)
              // window.console.log('x:',x);
              document.getElementById(itemId).style.color="red";
            },
            mouseLeaveItem(index){
              window.console.log('itemId:');
              var itemId='file_'+index
              document.getElementById(itemId).style.color="black";
            },


            DownLoadFile_byJs(item){
              var converted = htmlDocx.asBlob(this.doc); //,{orientation:'landscape'}           
              saveAs(converted, item.fileName);
            },

            save2docx(){
              var converted = htmlDocx.asBlob(this.doc+quill_css); //,{orientation:'landscape'}
                  // window.console.log('converted          :',this.doc+quill_css);
        
              saveAs(converted,  this.article.title+'.docx'); 
            },

            DownLoadFile(file,mode='from_server'){
              window.console.log('DownLoadFile file:',file);
              if(this.isMini){
                this.$message({
                  message: '小程序不支持下载,请访问网页版下载',
                  type: 'warning'
                });
                return
              }
             var that=this
              if(!this.islogin){
                this.$message({
                  message: '请先登录哦',
                    type: 'warning'
                  });
                  return
              }

              if(mode=='from_web'){

                that.download_web()

                // this.save2docx()
                return
              }


              let myCoins=this.$store.state.accountInfo.conis
              if(file.price){
                let price=file.price
                if(this.$store.state.accountInfo.vip==1 || this.$store.state.accountInfo.vip=='1' ){
                  price=price*0.5
                }

                this.$confirm('下载需要消耗您法币单位(会员半价)：'+price+'，是否同意？')
                .then(_ => {
                  // done();
                  that.downloading(file ,true)  //
                })
                .catch(_ => {
                  return
                });

              }else{
                that.downloading(file)
              }

 


            },

            download_web(){
              var that=this
              var datas= { 
                whattodo: "getDownLoad_web",
              }
              // datas['param']=this.param
              this.axios.post( this.$root.rootUrl+'article',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
                 
                      that.save2docx()


                    } else if (result.status=='fail'){
                      // window.console.log('get download link fail')
                      that.$message.error(result.failMsg);
                        
                    }

                }
                
              }).catch(function (error) {
                  window.console.log(error);
            
              });
            },

// getDownLoad_web

            downloading(file ,needcoin=false){
              var that=this
              var datas= { 
                whattodo: "getDownLoad",
                articleId:that.article.docid,
                fileName:file.fileName
              }
              // datas['param']=this.param
              this.axios.post( this.$root.rootUrl+'article',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
                      window.console.log('get download success')
                      // var blob = new Blob(result.link);
                      let link=result.link
                      link=link.replace("http://",'https://')

                      saveAs(link,file.fileName) 

                      // var aEle = document.createElement("a");// 创建a标签
                      // // blob = new Blob([content]); 
                      // aEle.download = fileName;// 设置下载文件的文件名
                      // //aEle.href = URL.createObjectUrl(blob);
                      // aEle.href = result.link;// content为后台返回的下载地址
                      // aEle.click();// 设置点击事件
                      if(needcoin){
                        that.refresh_coins()
                        that.$notify({
                            title: '提示',
                            message: '下载链接：'+link+'，请及时下载，链接6小时内有效',
                            type: 'success',
                            duration: 0,
                            offset:50,
                            width:100,
                            // dangerouslyUseHTMLString:true,
                            customClass: "notifycss",//自定义类名
                        });
                      }


                    } else if (result.status=='fail'){
                      // window.console.log('get download link fail')
                      that.$message.error(result.failMsg);
                        
                    }

                }
                
              }).catch(function (error) {
                  window.console.log(error);
            
              });
            },


            getCommentt_num(docid){
              var that=this
              var datas= { 
                docid:docid,
                whattodo: "get_comment_num"
              }
              this.axios.post('https://api.lawtip.cn/article_getdoc',datas
              ).then(function (res) {
                  if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
                      that.comment_number=result.data

                    }  

                  }

                  
                }).catch(function (error) {
                  window.console.log(error);
      
                });


            },

            Turn2Charge(){
              this.$router.push({path:'/deposit'})

            },


            refresh_coins() {
              var that=this

              console.log("this.$store.state.userInfo.userId:",this.$store.state.userInfo.userId)

              var datas= { 
                // userid: this.$store.state.userInfo.userId,
                userid:that.$root.userInfo.userId,
                whattodo:'getCoins',
              }
              this.axios.post(this.$root.rootUrl+'userinfo',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                  var result=res.data
                  window.console.log('result:',result,'result.status:',result.status)
                  if (result.status=='ok'){
                    that.myCoins=result.coins
                    that.$root.accountInfo.coins=result.coins

                    that.$store.commit('SetNewCoins',result.coins)

                  } 
                  else if (result.status=='fail'){
                    that.$message('获取余额失败，请稍后再试');
                    
                  } 

    

               }


            
              }).catch(function (error) {
                window.console.log(error);

              });


            },



            SignIn(){
                window.console.log('SignIn')
                // this.SignInVisibl=true 
                let num= getNum()
                window.console.log('num:',num)
                var nowurl = window.location.href;
                let target=window.btoa(nowurl)
                let state=num+'(redirect)'+target
                let url='https://open.weixin.qq.com/connect/qrconnect?appid=wxe00435b975483ad0&redirect_uri=http%3a%2f%2fwww.lawtip.cn%2f%23%2flogin&response_type=code&scope=snsapi_login&state='+state+'#wechat_redirect'
                
                localStorage.setItem("loginStatus", num);
                window.open(url,"_self")


                // window.open('http://www.lawtip.cn/wenshuDetail.html?'+timestamp, '_blank')

            },

            SignOut(){
                var that=this
                window.console.log('SignOut')
                delCookie()
           
                this.islogin=false

                sessionStorage.removeItem("isLogin");
                sessionStorage.removeItem("userInfo");
                sessionStorage.removeItem("accountInfo");

               
    

                // this.$notify({
                //     title: '成功',
                //     message: '成功退出登录',
                //     type: 'success'
                // });

                this.axios.get('../PHPserver/login/SignOut.php',{
                // params: {
                //     timestamp:timestamp
                // }
                }).then(function (res) { 
                    if(res.status==200){
                        window.console.log(res.data)
                        let result=res.data
                        if(result.status=='ok'){
                            // that.$root.userInfo=result.userInfo;
                            // that.$root.accountInfo=result.accountInfo;             			
                            that.islogin=false
                            that.userInfo.avatarUrl='@/assets/images/touxiang.png'
                            // window.open('/',"_self")
                            window.open(window.location.href,"_self")
                        }        


                    }

                }).catch(function (error) {
                    window.console.log(error);
                });






                

            },

            //  qrcode () {
            //   let that = this;
            //   let qrcode = new QRCode('qrcode', {
            //       width: 124,
            //       height: 124,        // 高度
            //       text:  that.link,   // 二维码内容
            //       // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            //       // background: '#f0f',   // 背景色
            //       // foreground: '#ff0'    // 前景色
            //   })
            // }
 
 




        
        }























        

       


    }
</script>

<style >
  @import '../../../assets/css/wordpaper/sheets-of-paper-a4.css';

  [v-cloak] {
    display: none;
  }
  
  .affix{
    display: flex;
    flex-direction: column;
    width:100%;
    /* border: 1px solid #dedede; */
    margin-top:10px;
    /* padding-top:10px; */
  }
  .affix a{
    text-decoration: none;
    color:black;
  }

  .affix .firstline{
    height: 35px;
    width:100%;
    /* padding: 8px 16px; */
    
    background-color: #f1f8ff;
    line-height: 35px;
    /* padding-left:15px; */
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

 

  .affix .firstline .left{
    width:60%;
    height: 100%;
  }

  .affix .firstline .right{
    width:40%;
    height: 100%;
    justify-content: flex-end;
    padding-right: 10px; 
    font-size:14px;
 
  }


  .affix .item{
    height: 40px;
    line-height: 40px;
    width:100%;
    /* border: 1px solid #b62121; */
    /* padding-left:15px; */
    display: flex;
    flex-direction: row;
    /* align-items: center; */
    margin-top:0;
    cursor: pointer;
    overflow: hidden;

  }
  .affix .item .icon{
    width:5%;
    height: 100%;
    justify-content: center;
    align-items:center;

  } 

  .affix .item .icon img{
    width:30px;
    height:30px;
  }

  .affix .item .left{
    width:35%;
    height: 100%;
    /* border: 1px solid #dedede; */

  }  

  .affix .item .mid{
    width:40%;
    height: 100%;
    /* border: 1px solid #dedede; */

  }  

  .affix .item .right{
    width:20%;
    height: 100%;
    justify-content: flex-end;
    padding-right:10px;

    /* border: 1px solid #bdbcbc; */
    display: flex;
    flex-direction: row;
    align-items: center;
  }  
  /* .affix .item .right button{
    height:70%;
  } */

.fileUpdateTime{
  margin:auto;
  font-size:12px;
  color:#9c9c9c;
}


  .editor_wrap{
   
    display: flex;
    flex-direction: column;
    /* border: 1px solid #333;  */
    /* justify-content: flex-start; */
  }

  .sharecode{
    /* border: 1px solid #d64545;  */
    margin:auto;
    /* margin-bottom:15px; */
  }
 

  .header_{
    width:100%;
    min-height: 55px;
    /* height: 55px; */
 
    border-bottom: 1px solid #e7e7e7; 
    display: flex;
    flex-direction: row;
  
 
    color:black;
    align-items: center;

  }

  .head_operation{
    width:40%;
    display: flex;
    flex-direction: row;
    /* border: 1px solid #ad3131;  */
    justify-content: flex-end;
    align-items:center;
    height: 100%;
    font-size:24px;
    padding-right: 15px;
  }

  .loginAvatar{
    width:10%;
    justify-content: flex-end;
    display: flex;
    flex-direction: row;
    align-items:center;
    text-align: right;
    height: 100%;
    /* border: 1px solid #ad3131;  */

  }

  .head_operation i{
    margin-left:50px;
    cursor: pointer;
  }

  .button_head{
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
 
  .middle{
    display: flex;
    flex-direction: row;
    /* padding-top:15px ;
    border: 1px solid rgb(185, 19, 19);  */
    /* margin-top: 55px; */
  }

  .left ,.right{
    width:18%;
    /* border: 1px solid rgb(19, 40, 156);  */

  }
  .mid_{
    display: flex;
    flex-direction: column;
    width:64%;
    /* border: 1px solid rgb(211, 233, 14);  */
    /* flex-wrap: wrap; */
    word-wrap:break-word;
    word-break:break-all;

  }

  .starBar{
    display: flex;
    flex-direction: row;
    width:100%;
    height: 40px;
    /* border: 1px solid rgb(211, 233, 14);   */
    justify-content: flex-end;
    align-items: center;
    line-height: 40px;
    /* position: relative; */

  }

  .starbox{
    border: 1px solid #c8e1ff;
    height: 80%;
    width:100%;
    margin-top:auto;
    margin-bottom: auto;
 
 
  }
  .starlikesnum{
    /* border-left: 1px solid #c8e1ff; */
    width:30%;
    height: 100%;
    font-size:22px;

  }
  .starBar .op{
    
    min-width:100px;
    height: 100%;
    /* border: 1px solid rgb(33, 88, 189);  */
    /* line-height: 60px; */
    /* padding: 5px; */
    cursor: pointer;
    /* float:right; */
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left:10px;
    justify-content: center;
   
 
  }

   .starBar .op button{
     height: 70%;
   }


  
 
/* 
  .el-icon-star-on,.el-icon-star-off{
    line-height: auto;
 
    height: 100%;
    width:100%;
    border: 1px solid rgb(8, 22, 48);
  } */

  /* .mid p{
    overflow: wrap;
  } */

  /* .divcontent{
    border: 1px solid rgb(211, 233, 14); 
    width:100%;
 
  } */
/* 
  .divcontent .img{
    
  } */
/* 
  .mid img{

    max-width:100%;
  } */

  .mid >>>  img{
    max-width:100%;
    display: block;
    margin:auto;
  }
  .mid >>> pre{
    background-color:#e9e8e8;
    overflow:scroll;
  }

  .contract_title{
    /* display: flex;
    flex-wrap: wrap; */
    min-height: 50px;
    width: 100%;
    line-height: 50px;
    font-size:30px;
    font-weight: normal;
  
    /* border: 1px solid rgb(211, 233, 14); */
  }
  .author{
    height: 50px;
    width:100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bottom{
    text-align: center;
    font-size: 12px;
  }

  .editor_class{
     height: 90%;
  }


  .bottom_op{
    height:60px;
    width:100%;
    /* border: 1px solid rgb(211, 233, 14);  */
    position:fixed;
    bottom:0;
    background-color: #fff;
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content: center;
    box-shadow:1.5px 1.5px 5px #909090;
   
  }
  .bottom_op_item{
    width:130px;
    height: 100%;
    /* border: 1px solid rgb(211, 233, 14);  */
    line-height: 60px;
    padding-left: 15px;
    cursor: pointer;
  }
  .bottom_op_icon{
    /* margin-left:45px; */
    /* line-height: 30px; */
    font-size:17px;
    font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
    color:#646464;
    cursor: pointer;
   
  }

  .html_content{
    /* border: 1px solid rgb(211, 233, 14); */
    /* padding-left:8px;
    padding-right:8px; */
  }

  .tagsBar{margin-top:25px}
  .tagsBar span{
    margin-right:20px;
  }
 

  /* .bottom_op_font{
    margin-left:5px;
    cursor: pointer;
    font-size:16px;
   
  } */

  .comments_box{

    /* display: flex;
    flex-direction: column; */
    /* border: 1px solid rgb(211, 233, 14); */
    width:100%;
    height:500px;
    overflow-y: scroll;
    /* width:100%;
    height: 100%; */


  }

  .comments_box .titleBar{
    width:90%;
    height: 50px;
    /* border: 1px solid rgb(16, 160, 148); */
    position:absolute;
    top:5px;
    display: flex;
    flex-direction: row;
    align-items:center;

  }

   .comments_box .titleBar .comment_num{
    width:65%;
    /* border: 1px solid rgb(16, 160, 148); */
    height: 100%;
    line-height: 50px;
    font-size:20px;

   }
  .comments_box .sortbar{
    float:right;
    width:30%;
    height: 30px;
    /* border: 1px solid rgb(16, 160, 148); */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items:center;
    margin-bottom: 5px;
    ;
    
  }

   .comments_box .sortbar span{
    cursor: pointer;
   }

  .comments_box .sortbar img {
    margin-right: 15px;
  }

  .inputComment{

    /* position: absolute;
    bottom: 5px; */
    /* border: 1px solid  #a3a3a3; */
    width:100%;
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
    align-items:center;

  }

  /* .inputComment el-input{
    width:80%;
  } */
  



  
    .comment_box{
        border-bottom:1px solid #dedede;
        width:95%;
        min-height: 150px;
        margin-right: auto;
        margin-left:auto;
        margin-top:15px;
        display: flex;
        flex-direction: column;

    }

 
    .comment_box_up{
        height:22%;
        width:100%;
        /* border:1px solid #2c232a; */
        display: flex;
        flex-direction: row;
        align-items:center;
    }
 

    .comment_box_down{
        height:72%;
        width:100%;
        /* border:1px solid #39a32f; */
        display: flex;
        flex-direction: row;

    }

    .comment_card{
        width: 100%;
        border:1px solid #dedede;

    }
    .title_comment{
      cursor: pointer; 
      /* border:1px solid #7a0202; */
      min-height: 25px;
      line-height: 25px;
      
    }
    .title_comment, .mid_comment, .bottom_comment{
        margin-bottom: 15px;
    }

    .title_comment .doclink{
        text-decoration: none;
        color:black;
    }

    .mid_comment{
        /* font-weight: lighter; */
        font-size: 14px;
        color:#aaa9a9;
    }
    .bottom_comment{
        font-size:12px;
        color:#aaa9a9;
    }
    .bottom_comment span{
        margin-right: 12px;
    }


    .comment_box_down.left{
        width:5%;
        height: 100%;
    }
    .comment_box_down.right{
        width:95%;
        height: 100%;

        /* border: #757575; */
    }


  .op_comment{
    font-size:14px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .op_comment span {
    margin-right:20px;
    /* color:#b8b6b6; */
    cursor: pointer;
  }











  

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px"!important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px"!important;;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px"!important;;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px" !important;;
}




.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本" !important;;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1" !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2" !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4" !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5" !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6" !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
 











@font-face {
  font-family: 'iconfont';  /* project id 1697282 */
  src: url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.eot');
  src: url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.woff') format('woff'),
  url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.svg#iconfont') format('svg');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* .icon-shanchu:before {
  content: "\e625";
}

.icon-praise:before {
  content: "\e501";
}

.icon-shoucang-copy:before {
  content: "\e52a";
}

.icon-fenxiangdaozhuanfafasongzhiyuanquanmianxing:before {
  content: "\e921";
}

.icon-zan:before {
  content: "\e509";
}

.icon-nolove:before {
  content: "\e508";
}

.icon-dianzan:before {
  content: "\e50f";
}

.icon-dianzan11-copy:before {
  content: "\e50a";
}

.icon-fenxiang:before {
  content: "\e606";
}

.icon-shanchu1:before {
  content: "\e603";
}

.icon-shoucang:before {
  content: "\e504";
} */

.ql-align-center{
  text-align: center;
}


.notifycss {
  /* white-space:pre-wrap !important;  */
  /* word-wrap: break-word; */
  word-break: break-all;
  /* height: auto;
  border: 1px solid #db1a1a;  */
 }

/* .el-notification .notifycss  {
   word-break: break-all;
} */
 
  
 

.hideimg{
  /* width: 100%; */
  height: 95%;
  position: absolute;
  /* object-fit:cover; */
  vertical-align:middle;
  z-index: 999;
  opacity: 0.1;
   -webkit-user-drag: none;
  /* border: 4px solid #db1a1a;  */
}
 

 
   
</style>
